export default __webpack_public_path__ + "static/media/momentick-logo-small.f634fa4a.png";